import TranslationSidebarInfo from "@/v2-backoffice-client/translation/sidebar/TranslationSidebarInfo"
import TranslationSidebarItem from "@/v2-backoffice-client/translation/sidebar/TranslationSidebarItem"
import type { PinnedSection } from "@/v2-backoffice-client/translation/sidebar/translation.sidebar.utils"
import { getTranslationViewHref } from "@/v2-backoffice-client/translation/translation.utils"
import type { TranslationView } from "@/v2-backoffice-client/translation/translation.constants"

export type TranslationSidebarPinnedSectionProps = {
  section: PinnedSection
  activeView: TranslationView
  // "All texts" (view "catalog") is also the base view for every category
  // row further down — it must stop reading as active the moment a specific
  // category is selected, or both would highlight at once.
  activeCategoryKey: string | null
}

function TranslationSidebarPinnedSection(
  props: TranslationSidebarPinnedSectionProps,
) {
  const { section, activeView, activeCategoryKey } = props

  return (
    <div className="translation-sidebar-section">
      <div className="translation-sidebar-section-header">
        {section.label}
        <TranslationSidebarInfo {...section.info} />
      </div>
      {section.items.map((item) => (
        <TranslationSidebarItem
          key={item.view}
          label={item.label}
          featureCode={item.featureCode}
          info={item.info}
          count={item.count}
          loading={item.loading}
          variant={item.attention ? "warning" : "muted"}
          isActive={
            activeView === item.view &&
            (item.view !== "catalog" || !activeCategoryKey)
          }
          to={getTranslationViewHref(item.view)}
        />
      ))}
    </div>
  )
}

export default TranslationSidebarPinnedSection
